import { SocialDialog } from './social-dialog';
import { DIALOG } from '../dialog-combiner';
import { transitions } from '../transition.config';
import { userModals } from 'core/User/modal.config';

DIALOG.add(userModals.PROFILE_SOCIAL, {
  component: SocialDialog,
  transition: transitions.SLIDE_UP,
  anchor: 'portal',
});
